export const CARRIER_LIST_KEY = 'CARRIER_LIST_KEY';
export const CARRIER_DETAIL_KEY = 'carrier-detail';
export const CARRIER_DRIVERS_LIST_KEY = 'DRIVER_LIST_KEY';
export const DRIVER_DETAIL_KEY = 'driver-detail';

export const getCarrierListKey = (params?: any) => [CARRIER_LIST_KEY, params];
export const getCarrierDetailKey = (id: string) => [CARRIER_DETAIL_KEY, id];
export const getCarrierDriversListKey = (carrierId: string, params?: any) => [
  CARRIER_DRIVERS_LIST_KEY,
  carrierId,
  params,
];
export const getDriverDetailKey = (id: string) => [DRIVER_DETAIL_KEY, id];
